import { Routes } from '@angular/router';
import { ConfirmIdentity } from './confirm-identity/confirm-identity.component';
import { LoginComponent } from './login/login.component';
import { LogoutComponent } from './logout/logout.component';
import { NoAccessComponent } from './noaccess.component';

export const APP_ROUTES: Routes = [
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'logout',
    component: LogoutComponent,
  },
  { path: 'noaccess', component: NoAccessComponent },
  { path: 'username', component: ConfirmIdentity },
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: '**', redirectTo: 'login', pathMatch: 'full' },
];
